import { Region } from "./Region";

// Represents a DB table or combination of DB tables valid in all regional instances
const _ResourceRegional = {
  AuditLogConfigVariables: "audit_logs/config_variables",
  AuditLogProject: "audit_logs/projects",
  BoxToken: "box_tokens",
  ConfigVariable: "config_variables",
  DemoProjectTemplate: "demo_project_templates",
  DemoProjectUser: "demo_project_users",
  DropboxToken: "dropbox_tokens",
  FeatureFlag: "feature_flags",
  ManualWorker: "manual_workers",
  MicrosoftToken: "microsoft_tokens",
  Project: "projects",
  ProjectsUser: "projects_users",
  StressTestingProject: "stress_testing/generate_project",
  SyncError: "sync_errors",
} as const;

export const ResourceRegional = _ResourceRegional;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ResourceRegional =
  (typeof _ResourceRegional)[keyof typeof _ResourceRegional];

const RESOURCE_REGIONAL_VALUES = new Set<string>(
  Object.values(ResourceRegional),
);

export function isResourceRegional(value: string): value is ResourceRegional {
  return RESOURCE_REGIONAL_VALUES.has(value);
}

export function getRegionalResourceName(
  region: Region,
  resource: ResourceRegional,
): string {
  return `${region}/${resource}`;
}
